import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { connect } from 'react-redux'
import setSearchProductSystemAction from '../../redux/actions/searchReferenceActions/actionSearchProductSystem'
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-notchedOutline': {
    '&:hover': {
      borderColor: "rgb(0,191,255)",
    },
    '&.Mui-focused': {
      borderColor: "rgb(47, 79, 79)",
    },
  },
  '& .Mui-focused': {
    color: 'white',
  },
  width: 300,
  fontSize: 30,
  backgroundColor: 'rgba(19, 174, 236, 0.54)',
  fontWeight: 'bold'
});

class SearchProductSystemForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = { searchProductSystem: '', searchProductSystems: [
            {prodsys:  'Wood Coating'},
            {prodsys:  'Tile Care Products and Accessories'},
            {prodsys:  'Tile Adhesive'},
            {prodsys:  'Surface Protection - Resin'},
            {prodsys:  'Surface Protection - Mineral'},
            {prodsys:  'Surface Protection - Dispersion'},
            {prodsys:  'Structural Strenghtening'},
            {prodsys:  'Sealants and Joint Profiles'},
            {prodsys:  'Screeds'},
            {prodsys:  'Road Resins'},
            {prodsys:  'Resin Flooring'},
            {prodsys:  'Release Agents'},
            {prodsys:  'Raw Materials and Precursors'},
            {prodsys:  'Primers for Tiling Systems'},
            {prodsys:  'Plasters & Masonry Mortars'},
            {prodsys:  'not yet allocated'},
            {prodsys:  'Not Assignable'},
            {prodsys:  'Noise Reduction and Decoupling Syst'},
            {prodsys:  'Mold Stop'},
            {prodsys:  'Mineral Waterproofing'},
            {prodsys:  'Membrane Waterproofing'},
            {prodsys:  'Marketing and Promotion'},
            {prodsys:  'Leveling Mortars'},
            {prodsys:  'Landscaping and Gardening'},
            {prodsys:  'Konudur Liner Systems'},
            {prodsys:  'Injection'},
            {prodsys:  'Hydrophobic Agents'},
            {prodsys:  'Grouts for Tiling'},
            {prodsys:  'Grouts'},
            {prodsys:  'Floor Adhesives'},
            {prodsys:  'ECI Sealants'},
            {prodsys:  'Dispersion Waterproofing'},
            {prodsys:  'Curing Agents'},
            {prodsys:  'Costs/Freights/Discounts'},
            {prodsys:  'Concrete Repair'},
            {prodsys:  'Concrete Cosmetics and Design'},
            {prodsys:  'Cement-Free Mortar Systems'},
            {prodsys:  'Building Boards'},
            {prodsys:  'Bituminous Waterproofing'},
            {prodsys:  'Admixtures'},
            {prodsys:  'Adhesives'},
            {prodsys:  'Additives for Concrete Goods'},
            {prodsys:  'Additions for Concrete'},
            {prodsys:  'Available'},

        ]};
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeForm = this.handleChangeForm.bind(this);
        this.props.setSearchProductSystemFunction('');
    }

  // fetch by adding charachters in searchProductSystem-inputform
   handleChange(event) {
    if(event.target.value.length > 0) {
    this.setState({ searchProductSystem: event.target.value});
  }
  };

  handleChangeForm(event, value) {
    if (value !== null) {
      this.setState({ searchProductSystem: value.prodsys}, () => {
        this.props.setSearchProductSystemFunction(this.state.searchProductSystem);
      });
    } 
    else {
      this.setState({ searchProductSystem: ''}, () => {
        this.props.setSearchProductSystemFunction(this.state.searchProductSystem);
      });
    }
  }

    render() {

      const { classes } = this.props;
      const { t } = this.props;

        return (
            <div>
                <Autocomplete
                classes={classes}
                    id="combo-box-productSystem"
                    onChange={this.handleChangeForm}
                    options={this.state.searchProductSystems}
                    isOptionEqualToValue={(option, value) => option.searchProductSystem === value.searchProductSystem}
                    getOptionLabel={(option) => option.prodsys}
                    noOptionsText={'Wrong input data'}
                    renderInput={(params) => <StyledTextField {...params} style={{ fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300 }} onChange={this.handleChange} label={t("search_ref.search_prod_sys")} variant="outlined" />}
                />
            </div>
        );
    }
}

 const mapDispatchToProps = dispatch => {
     return {
    setSearchProductSystemFunction: searchProductSystem  => {
        dispatch(setSearchProductSystemAction(searchProductSystem))
    }
     }
}

export default connect (null, mapDispatchToProps)(withTranslation()(SearchProductSystemForm));